<template>
  <div class="rewards-progress">
    <div v-if="steps.length" class="rewards-levels">
      <span v-for="({ label, offset }, i) in steps" :key="i" :style="{ left: `${offset}%` }">{{ label }}</span>
    </div>
    <div class="rewards-progress-bar">
      <div class="earned-progress-bar bg-primary-a8" :style="{ width: `${width}%` }"/>
    </div>
  </div>
</template>

<script>
import _uniq from 'lodash/uniq';

export function formatData({ breaks, value }) {
  let highest = 50;

  if (Array.isArray(breaks) && breaks.length > 0) {
    highest = (h => h > highest ? h : highest)(_uniq(breaks).sort((a, b) => a - b).slice().pop());
    highest = highest > 1000 ? highest * 1.05 : (highest > 100 ? highest * 1.1 : highest);
  }
  if (value > highest) {
    highest = value;
  }

  return {
    steps: breaks.map(label => ({ label, offset: (label / highest) * 100 })),
    width: (value / highest) * 100,
  };
}

export default {
  name: 'RewardsProgress',
  props: {
    breaks: {
      type: Array,
      default: () => [],
      // Ensure all items in the array are numbers!
      validate: a => Array.isArray(a) && a.reduce((b, v) => b && typeof v === 'number', true),
    },
    value: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    const { steps, width } = formatData({ breaks: this.breaks, value: this.value });
    return { steps, width };
  },
};
</script>

<style lang="scss">
.rewards-progress {
  width: 100%;

  .rewards-levels {
    position: relative;
    height: 2.4rem;

    span {
      position: absolute;

      &:after {
        content: '|';
        position: absolute;
        bottom: -15px;
        left: 3px;
      }
    }
  }

  .rewards-progress-bar {
    background-color: #fff;
    height: 1rem;
    width: 100%;
  }
  .earned-progress-bar {
    background-color: #eee;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rewards/Progress.vue